import Chart from "react-apexcharts";

import {NoData} from "@/pages/rum/v2/details/graphs/fc/NoData.tsx";
import {barLabelFormatter, parseData} from "@/pages/rum/v2/details/graphs/fc/utils.ts";
// @ts-expect-error legacy
import {defaultGraphOptions, toolbarExportOptions} from "@/pages/rum/v2/details/graphs/GraphFormatter";
import {Colors} from "@/pages/rum/v2/RumColors.ts";
// @ts-expect-error legacy
import {datetimeFormatter, defaultFormatter} from "@/pages/rum/v2/RumUtils";

export const DetailTrendGraphFC = ({
  checkName,
  title,
  bar,
  left,
  right,
  data,
  baselines,
  timezone,
  noDataMessage,
  headerData,
}: {
  bar: boolean;
  checkName: string;
  title?: string;
  noDataMessage?: string;
  timezone: string;
  headerData: JSON;
  data: unknown;
  right: unknown;
  left: unknown;
  baselines: unknown;
}) => {
  const defaultOptions = defaultGraphOptions();
  const options = {
    chart: {
      ...defaultOptions.chart,
      markers: {
        size: 20,
      },
      toolbar: {
        ...defaultOptions.chart.toolbar,
        ...toolbarExportOptions(checkName, "trend"),
      },
    },
    title: defaultOptions.title,
    grid: {
      padding: {
        top: 3,
        bottom: 3,
      },
    },
    colors: (bar ? [Colors.ghostBlue] : []).concat([
      Colors.lightBlue,
      Colors.blue,
      Colors.turquoise,
      Colors.saffron,
      Colors.mediumLightBlue,
    ]),
    stroke: {
      width: [bar ? 0 : 5, 5, 5, 5, 5],
    },
    plotOptions: {
      bar: {
        dataLabels: {
          position: "bottom",
        },
        stroke: {
          show: false,
        },
      },
    },
    dataLabels: bar
      ? {
          enabled: true,
          enabledOnSeries: [0],
          // @ts-expect-error legacy
          formatter: (_, options) => barLabelFormatter(data, options, timezone),
          background: {
            enabled: false,
          },
          offsetY: 30,
          style: {
            colors: [Colors.black],
            fontWeight: 100,
          },
        }
      : {},
    xaxis: {
      type: "datetime",
      labels: {
        show: !bar,
        // @ts-expect-error legacy
        formatter: (value) => {
          // @ts-expect-error legacy
          if (value == null || !data || !data.length) {
            return "";
          }
          const timeKey = "EventTime";
          // @ts-expect-error legacy
          return datetimeFormatter(value, data[0][timeKey], data[data.length - 1][timeKey], {timezone: timezone});
        },
      },
      tooltip: {
        enabled: false,
      },
    },
    yaxis: [
      {
        // @ts-expect-error legacy
        seriesName: (left || {}).name,
        title: {
          // @ts-expect-error legacy
          text: (left || {}).name,
          style: {
            color: Colors.lightBlue,
            fontSize: "14px",
            fontWeight: 400,
          },
        },
        labels: {
          // @ts-expect-error legacy
          formatter: (value) => defaultFormatter(value, 2, left),
          style: {
            colors: [Colors.lightBlue],
          },
        },
        tickAmount: 3,
      },
    ],
    legend: {
      ...defaultOptions.legend,
      offsetY: 10,
    },
    tooltip: {
      x: {
        // @ts-expect-error legacy
        formatter: (value) => datetimeFormatter(value, null, null, {timezone: timezone}),
      },
      y: {
        // @ts-expect-error legacy
        formatter: (value, options) => {
          const allFeatures = (left ? [left] : []).concat(right || []).concat(baselines || []);
          const feature = allFeatures[options.seriesIndex];
          return defaultFormatter(value, 3, feature);
        },
      },
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
    },
  };
  const {series, yaxis, dashArray, noData} = parseData(data, left, right, baselines, bar, options, headerData);
  return (
    <div className="detail-trend-graph">
      {noData && <NoData message={noDataMessage} />}
      <Chart
        type="line"
        options={{
          ...options,
          yaxis: yaxis,
          title: {
            ...options.title,
            text: title,
          },
          stroke: {
            ...options.stroke,
            dashArray: dashArray,
          },
          // @ts-expect-error legacy
          xaxis: {
            ...options.xaxis,
            labels: {
              show: !bar,
            },
          },
        }}
        series={series}
        width="100%"
        height="300px"
      />
    </div>
  );
};
